// extracted by mini-css-extract-plugin
module.exports = {"root":"PregameStageStatus_root__3tnvF","day":"PregameStageStatus_day__XEK5R","time":"PregameStageStatus_time__8MDOH"};